export default {
  home: {
    title: 'HTML5 Games Collection',
    subtitle: 'Play instantly in your browser. No downloads, just fun!',
    browseGames: 'Browse Games',
    popularGames: 'Popular Games',
    newGames: 'New Games',
    recommendedGames: 'Recommended Games',
    recentlyPlayed: 'Recently Played',
    popular: 'Popular',
    genres: {
      casual: 'Casual',
      puzzle: 'Puzzle',
      racing: 'Racing',
      racing_driving: 'Racing & Driving',
      shooter: 'Shooter',
      simulation: 'Simulation',
      strategy: 'Strategy',
      sports: 'Sports',
      agility: 'Agility',
      battle: 'Battle',
      care: 'Care',
      cooking: 'Cooking',
      football: 'Football',
      '.IO': 'Real-time Battles',
      merge: 'Merge',
      all: 'All',
      other: 'Other',
      dressup: 'Dress-up',
      adventure: 'Adventure',
      mahjong_connect: 'Mahjong & Connect',
      jigsaw: 'Jigsaw',
      basketball: 'Basketball',
      quiz: 'Quiz',
      bubble_shooter: 'Bubble Shooter',
      match3: 'Match-3',
      boardgames: 'Boardgames',
      educational: 'Educational',
      cards: 'Cards'
    }
  },
  games: {
    playNow: 'Play Now',
    relatedGames: 'Related Games',
    instructions: 'Game Instructions',
    controlsTitle: 'Game Controls',
    addToFavorites: 'Add to Favorites',
    removeFromFavorites: 'Remove from Favorites',
    share: 'Share Game',
    reportIssue: 'Report Issue',
    fullscreen: 'Fullscreen Mode',
    exitFullscreen: 'Exit Fullscreen'
  },
  categories: {
    title: 'Game Categories',
    subtitle: 'Explore our rich game categories',
    allCategories: 'All Categories',
    gamesInCategory: '{count} Games',
    categoryDescription: 'Here you can find all games in the {category} category. Pick from different styles and start playing immediately!',
    pageTitle: 'Game Categories',
    pageDescription: 'Explore our diverse game categories and find your favorite game type',
    allGames: 'All Games',
    gamesFound: '{count} Games Found',
    other: 'Other',
    taggedGames: '{tag} Games',
    noGamesInCategory: 'No Games in This Category',
    loadMore: 'Load More',
    otherGames: 'Other Games',
    seoTitle: 'GoGameVault - Game Categories | Free Online HTML5 Games',
    seoDescription: 'Explore diverse game categories on GoGameVault, including action, puzzle, arcade, sports, racing and more, to find your favorite type of game.',
    seoKeywords: 'game categories,online games,free games,HTML5 games,browser games',
    descriptions: {
      'Casual': 'Easy and simple casual games suitable for players of all ages, enjoy gaming without pressure.',
      'Puzzle': 'Brain training puzzle games that bring satisfaction through solving riddles and mental challenges.',
      'Racing & Driving': 'Experience speed and excitement in thrilling racing and driving games across various tracks.',
      'Shooter': 'Test your aim accuracy and reaction time in shooting games, defeat all enemies.',
      'Simulation': 'From city management to aircraft piloting, simulate various real-world experiences and roles.',
      'Strategy': 'Strategy games requiring careful planning and tactical thinking to achieve victory.',
      'Sports': 'Sports games simulating various athletic events, showcase your sporting talent.',
      'Agility': 'Agility games testing reaction speed and coordination, quickly respond to various challenges.',
      'Battle': 'Battle games featuring intense competition, win through skill and strategy.',
      'Care': 'Care games offering the joy of looking after pets, patients, or other characters.',
      'Cooking': 'Show off your culinary skills, create delicious dishes and manage restaurants.',
      'Football': 'Experience the world\'s most popular sport, showcase your soccer skills and tactics.',
      '.IO': 'Real-time battle games, multiplayer online competitive games where you compete and grow with players worldwide.',
      'Merge': 'Merge games where you create new items by combining identical ones, simple yet addictive.',
      'other': 'Unique gaming experiences that don\'t fit into regular categories.',
      'generic': 'Explore various {tag} games and find your favorites.'
    }
  },
  search: {
    title: 'Search Results',
    placeholder: 'Search games...',
    resultsFor: 'Search results for "{query}"',
    noResults: 'No Games Found',
    noResultsMessage: 'No games found related to "{query}"',
    tryAgain: 'Please try with different keywords or browse our categories.',
    returnToHomepage: 'Return to Homepage',
    foundResults: 'Found {count} games',
    seoTitle: 'Search "{query}" - GoGameVault | Free Online HTML5 Games',
    seoDescription: 'Search for "{query}" related free online HTML5 games on GoGameVault. Find various fun games, no download required, play directly in your browser.'
  },
  gameDetail: {
    title: 'Game Details',
    gameTitle: 'Game Title',
    genres: 'Game Genres',
    tags: 'Tags',
    gameDescription: 'Game Description',
    controlsAndInstructions: 'Controls and Instructions',
    similarGames: 'Similar Games',
    new: 'New Game',
    playAmazingGame: 'Play this amazing game now',
    noSimilarGames: 'No similar games',
    gameNotFound: 'Game Not Found',
    gameNotExistOrRemoved: 'This game does not exist or has been removed',
    backToHome: 'Back to Homepage',
    seoTitle: '{title} - Play Free Online | GoGameVault',
    seoTitleNotFound: 'Game Not Found | GoGameVault',
    seoKeywords: '{title}, online games, free games, {tags}, HTML5 games',
    gameUnavailable: 'Game Temporarily Unavailable',
    tryAgainLater: 'Please try again later',
    share: 'Share',
    openInNewTab: 'Open in New Tab'
  },
  about: {
    title: 'About Us',
    aboutUs: 'About Us',
    ourMission: 'Our Mission',
    contactUs: 'Contact Us',
    privacyPolicy: 'Privacy Policy',
    termsOfService: 'Terms of Service',
    feedbackTitle: 'Feedback',
    feedbackText: 'We are constantly working to improve our website. If you have any suggestions or find any issues, please let us know!',
    missionTitle: 'Our Mission',
    missionText1: 'GoGameVault is dedicated to providing users with the best free online gaming experience. We carefully select fun, high-quality HTML5 games that you can enjoy without downloading.',
    missionText2: 'Our goal is to create a user-friendly gaming platform where players can easily find and play the games they like.',
    feature1Title: 'Curated Games',
    feature1Text: 'We carefully select each game to ensure high-quality graphics and smooth gameplay.',
    feature2Title: 'Play Anytime, Anywhere',
    feature2Text: 'All games run directly in your browser with no need to download or install additional software.',
    feature3Title: 'Completely Free',
    feature3Text: 'All our games are completely free, with no hidden fees or in-app purchases.',
    contactTitle: 'Contact Us',
    contactText: 'If you have any questions, suggestions, or feedback, please feel free to contact us. We value user opinions and are committed to continuously improving our services.',
    seoTitle: 'GoGameVault - About Us | Free Online HTML5 Games',
    seoDescription: 'GoGameVault is a free online HTML5 game platform offering curated games that you can play anywhere without downloading. Learn about our mission and features.',
    seoKeywords: 'online games,free games,HTML5 games,browser games,no download'
  },
  notFound: {
    title: 'Page Not Found',
    message: 'Sorry, the page you visited does not exist or has been removed. Let us get you back on track!',
    returnHome: 'Return to Homepage',
    goBack: 'Go Back',
    popularGames: 'Popular Game Recommendations',
    popularGamesDesc: 'Explore these featured games to start your gaming journey',
    seoTitle: 'Page Not Found - GoGameVault',
    seoDescription: 'Sorry, the page you visited does not exist on GoGameVault. Browse our popular games for a new gaming experience.'
  },
  categoryGames: {
    games: 'Games',
    gamesAvailable: '{count} Games Available',
    noGamesFound: 'No Games Found',
    noGamesInCategory: 'No Games in This Category',
    exploreCategories: 'Explore Other Categories',
    backToCategories: 'Back to Categories',
    invalidCategory: 'Invalid Category',
    categoryNotExist: 'The category you are looking for does not exist.',
    browseCategories: 'Browse All Categories',
    category: 'Category',
    seoTitle: '{tag} Games - Play Online - GoGameVault',
    seoDescriptionWithGames: 'Browse and play {count} featured {tag} games for free. All games can be played directly in your browser with no download required.',
    seoDescriptionDefault: 'Browse and play our {tag} games for free. All games can be played directly in your browser with no download required.',
    seoKeywords: '{tag} games,free online games,browser games'
  }
}; 